import { render, staticRenderFns } from "./VideoMenu.vue?vue&type=template&id=bf53d90c&"
import script from "./VideoMenu.vue?vue&type=script&lang=js&"
export * from "./VideoMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VCol,VIcon,VList,VListItem,VListItemGroup,VMenu,VSubheader})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4196850391/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf53d90c')) {
      api.createRecord('bf53d90c', component.options)
    } else {
      api.reload('bf53d90c', component.options)
    }
    module.hot.accept("./VideoMenu.vue?vue&type=template&id=bf53d90c&", function () {
      api.rerender('bf53d90c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VideoMenu.vue"
export default component.exports